import './App.css';
import { TodoList } from './components/TodoList';
function App() {
  return (
    <div className="flex justify-center items-center ">
      <TodoList/>
    </div>
  );
}

export default App;
